import { render, staticRenderFns } from "./ViewPDF.vue?vue&type=template&id=64509683&"
import script from "./ViewPDF.vue?vue&type=script&lang=js&"
export * from "./ViewPDF.vue?vue&type=script&lang=js&"
import style0 from "./ViewPDF.vue?vue&type=style&index=0&id=64509683&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports